import { ApolloClient, InMemoryCache, split, HttpLink } from "@apollo/client";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
import { getMainDefinition } from "@apollo/client/utilities";
import { setContext } from "@apollo/client/link/context";

// 🔹 Récupération du token depuis les cookies
export function getAuthTokenFromCookie(cookieName) {
  const match = document.cookie.match(new RegExp(`(^| )${cookieName}=([^;]+)`));
  return match ? match[2] : null;
}

const config = window.__ENV__ || {};
const runtimeEnv =
  typeof process !== "undefined" && process?.env ? process.env : {};
const isRuntimePlaceholder = (value = "") =>
  typeof value === "string" && /^__.+__$/.test(value);
const pickValidConfigValue = (...values) =>
  values.find((value) => value && !isRuntimePlaceholder(value));
const controllerApiUrl =
  pickValidConfigValue(
    config.CONTROLLER_API_URL,
    runtimeEnv.REACT_APP_CONTROLLER_API_URL
  ) || "/graphql";
const controllerApiWs =
  pickValidConfigValue(
    config.CONTROLLER_API_WS,
    runtimeEnv.REACT_APP_CONTROLLER_API_WS
  ) ||
  `${window.location.protocol === "https:" ? "wss" : "ws"}://${
    window.location.host
  }/graphql`;

if (!pickValidConfigValue(config.CONTROLLER_API_URL, runtimeEnv.REACT_APP_CONTROLLER_API_URL)) {
  console.warn(
    "Missing CONTROLLER_API_URL runtime config, using fallback '/graphql'."
  );
}

if (!pickValidConfigValue(config.CONTROLLER_API_WS, runtimeEnv.REACT_APP_CONTROLLER_API_WS)) {
  console.warn(
    `Missing CONTROLLER_API_WS runtime config, using fallback '${controllerApiWs}'.`
  );
}

// 🔹 HTTP link
const httpLink = new HttpLink({
  uri: controllerApiUrl,
});

// 🔹 Middleware pour ajouter le token aux headers HTTP
const authLink = setContext((_, { headers }) => {
  const token = getAuthTokenFromCookie("ZORNI_AUTH_TOKEN");

  if (!token || token === "undefined") {
    console.warn("❌ No token, HTTP request will be sent without authorization header");
    return {
      headers: {
        ...headers,
      },
    };
  }

  return {
    headers: {
      ...headers,
      Authorization: `Bearer ${token}`,
    },
  };
});

// 🔹 HTTP final link (middleware + http)
const authedHttpLink = authLink.concat(httpLink);

// 🔹 WS link factory
function createLazyWsLink() {
  return new GraphQLWsLink(
    createClient({
      url: controllerApiWs,
      lazy: true,
      reconnect: true,
      connectionParams: () => {
        const token = getAuthTokenFromCookie("ZORNI_AUTH_TOKEN");
        if (!token || token === "undefined") {
          console.warn("❌ No token, WS connection will not be created");
          return {};
        }
        return { token };
      },
    })
  );
}

// 🔹 Split link : HTTP pour query/mutation, WS pour subscription
const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  createLazyWsLink(),
  authedHttpLink // <── le HTTP avec token !
);

// 🔹 Apollo client
export const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});
